module.exports = __webpack_public_path__ + "static/img/9.8b86551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/9.png
// module id = v4oB
// module chunks = 0